import { useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  required,
  useRecordContext,
  SaveButton,
  Toolbar,
} from "react-admin";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ModelUpload } from "./ModelUpload";
import { OtherPropertiesPanel } from "./OtherPropertiesPanel";
import { PerspectivesPanel } from "./PerspectivesPanel";

function EditToolbar() {
  const navigate = useNavigate();
  return (
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton />
      <Button onClick={() => navigate(-1)}>Annulla</Button>
    </Toolbar>
  );
}

function ModelTitle() {
  const record = useRecordContext();
  return <span>Modello: {record ? record.name : ""}</span>;
}


export function ModelEdit() {
  // Bumped by ModelUpload after a successful confirm so PerspectivesPanel
  // (which fetches independently of react-admin's data provider / refresh())
  // knows to refetch — otherwise a server-auto-created "Vista predefinita"
  // perspective on first upload never appears without a page reload.
  const [perspectivesVersion, setPerspectivesVersion] = useState(0);

  return (
    // mutationMode="pessimistic" (react-admin defaults to "undoable", which
    // redirects to /projects optimistically BEFORE the PUT is even sent, ~5s
    // ahead of the actual save). ProjectList's ModelSubList fetches model data
    // via a raw dataProvider.getList() call outside react-admin's query cache,
    // so re-expanding a project during that window fetched genuinely stale
    // data straight from the server, with no signal to refetch once the real
    // save landed — the reported "needs a hard refresh to see the update" bug.
    <Edit title={<ModelTitle />} redirect="/projects" mutationMode="pessimistic">
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput source="id" label="ID" disabled fullWidth />
        <ReferenceInput source="project_id" reference="projects">
          <SelectInput
            optionText="name"
            label="Progetto"
            validate={[required()]}
            fullWidth
          />
        </ReferenceInput>
        <TextInput
          source="name"
          label="Nome modello"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="description"
          label="Descrizione"
          multiline
          rows={4}
          fullWidth
        />
        <TextInput
          source="knowledge"
          label="Conoscenza"
          multiline
          rows={4}
          fullWidth
        />
        <PerspectivesPanel refreshKey={perspectivesVersion} />
        <OtherPropertiesPanel />
        <ModelUpload onUploaded={() => setPerspectivesVersion((v) => v + 1)} />
      </SimpleForm>
    </Edit>
  );
}
